/** pickup-instructions slug — org settings re-export. @see docs/OPT_IN_ORDER_DOCUMENTS.md */
export {
  type PickupInstructionsDocumentConfig,
  PickupInstructionsDocumentConfigSchema,
} from "~/shared/documents/schemas/pickup-instructions-config.schema";
